import { render, staticRenderFns } from "./ArchivedTasks.vue?vue&type=template&id=10d0ec0f&"
import script from "./ArchivedTasks.vue?vue&type=script&lang=js&"
export * from "./ArchivedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports